import { Flex, Typography, theme } from 'antd';

const { Text } = Typography;

interface TodaysDownloadsTotalProps {
  totalDownloads: number;
}

const TodaysDownloadsTotal = ({ totalDownloads }: TodaysDownloadsTotalProps) => {
  const { token } = theme.useToken();

  return (
    <Flex vertical style={{ flexShrink: 0, minWidth: 110 }}>
      <Text
        style={{
          fontSize: token.fontSizeLG,
          color: token.colorTextSecondary,
          whiteSpace: 'nowrap',
          marginBottom: 5,
        }}
      >
        Today's downloads
      </Text>
      <Text
        style={{
          color: token.colorTextHeading,
          fontFamily: token.fontFamily,
          fontSize: token.fontSizeHeading3,
          fontWeight: token.fontWeightStrong,
          lineHeight: token.lineHeightHeading3,
          whiteSpace: 'nowrap',
        }}
      >
        {totalDownloads.toLocaleString()}
      </Text>
    </Flex>
  );
};

export default TodaysDownloadsTotal;
